import React from 'react';
import { Link } from "react-router-dom";
import NotificationPanel from "./components/NotificationPanel";
import {changeUserSettings} from '../services/UserService'

class EditSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           jwtToken: props.jwtToken,
           mail: props.mail,
           oldPass: "",
           newPass: "",
           newPassAgain: "",
           notifyMessage: ""
        };
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout(e){
        window.sessionStorage.removeItem("jwtToken");
        window.sessionStorage.removeItem("userMail");
        window.sessionStorage.removeItem("isAdmin");
        this.props.handleLogout(null, null, null);
        window.location.pathname = "/";
    }

    handleCreateInputChange = (e) => {
        if (e.target.name === "mail") {
            this.setState({ mail: e.target.value});
        }
        else if (e.target.name === "oldPass") {
            this.setState({ oldPass: e.target.value});
        }
        else if (e.target.name === "newPass") {
            this.setState({ newPass: e.target.value});
        }
        else if (e.target.name === "newPassAgain") {
            this.setState({ newPassAgain: e.target.value});
        }
    };

    handleCreateSubmit = (e) => {
        e.preventDefault();
        if (this.state.mail === "") {
            this.setState({notifyMessage: "Mail field must not be empty."});
        } else if (
        (this.state.newPass !== "" || this.state.newPassAgain !== "")
        && this.state.newPass !== this.state.newPassAgain ) {
            this.setState({ notifyMessage: "New password fields must either match, or stay empty."});
        } else {
            changeUserSettings(this.state.jwtToken,
            this.state.mail, this.state.oldPass, this.state.newPass)
                .then(response =>{
                    if (response.ok){
                        window.alert("User data changed successfully.\nPlease login with new credentials to apply changes.");
                        this.handleLogout();
                    } else {
                        this.setState({ notifyMessage: "Error: Incorrect old password OR Mail already exists."});
                    }
                }
            );
        }
    };

    render() {
    return (
    <>
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>
                <Link to="/">
                    <span title="Return to experiment listing">All experiments/</span>
                </Link>
                Edit user settings
            </h1>
            <form style={{width: "350px", paddingTop:"10px"}}>
                <h3>Change mail</h3>
                <div className="form-group">
                    <label>Mail</label>
                    <input className="form-control" type="text" name="mail" placeholder="Your email" value={this.state.mail}
                    onChange={(e) => this.handleCreateInputChange(e)} />
                </div>
                <hr />
                <h3>Change password</h3>
                <div className="form-group">
                    <label>Old password</label>
                    <input className="form-control" type="password" name="oldPass" title="Old password"
                    onChange={(e) => this.handleCreateInputChange(e)}/>
                </div>
                <div className="form-group">
                    <label>New password</label>
                    <input className="form-control" type="password" name="newPass" title="New password"
                    onChange={(e) => this.handleCreateInputChange(e)}/>
                </div>
                <div className="form-group">
                    <label>New password again</label>
                    <input className="form-control" type="password" name="newPassAgain" title="New password again"
                    onChange={(e) => this.handleCreateInputChange(e)}/>
                </div>
                <button type="submit" className="btn btn-primary" onClick={this.handleCreateSubmit} >
                    Submit
                </button>
                <NotificationPanel type="error" message={this.state.notifyMessage}/>
            </form>
        </div>
    </>
    );
    }
}

export default EditSettings;
